var _linearGradient, _linearGradient2, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTapo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1206,
    x2: 10.25,
    y1: 23.2759,
    y2: 23.2759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f74fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1dc6ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 28.6493,
    x2: 28.6493,
    y1: 9.87107,
    y2: 37.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f74fc"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#262f30",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.2759 9.25 6.8318 5.0203-11.8105 9.1496c-.6304.4884-.9456.7326-1.1147 1.0775s-.1691.7437-.1691 1.5411v11.2115h-4.037c-1.7566 0-2.635 0-3.1807-.5457s-.5457-1.4241-.5457-3.1807v-8.2405c0-2.9127 0-4.3691.6378-5.6138.6379-1.2448 1.82-2.0954 4.1842-3.7966z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.104 9.87107c-1.0655 1.02003-1.5983 1.52993-1.9369 2.02333-1.4905 2.1715-1.3296 5.075.3917 7.0685.3911.4529.9769.9009 2.1486 1.7969l3.5453 2.7112c.5725.4377.8587.6566 1.0265.9595.0251.0452.048.0917.0687.1391.1387.3172.1387.6775.1387 1.3982v11.2822h4.037c1.7566 0 2.635 0 3.1807-.5457s.5457-1.4241.5457-3.1807v-8.1792c0-2.8927 0-4.3391-.6302-5.5778-.6303-1.2387-1.7994-2.0903-4.1377-3.7933z",
    fill: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapo);
export default __webpack_public_path__ + "static/media/tapo.fd044b397222b51c50cd50a6f1984c1d.svg";
export { ForwardRef as ReactComponent };